import { Stack } from "@mui/material"
import { Button } from "@mui/material";
import { Typography } from "@mui/material"
import React from 'react'
import { PopupMessageWrapper } from "./PopupMessageWrapper";
import { useHoleSettings } from "../Context/useHoleSettingsContext";
import { useLSContext } from "../Context/useLSContext";
import { deleteCookie } from "../Context/CookieContext";
import { clearLastHole } from "../utils/lastHoleStorage";
import { useDataContext } from "../Context/useDataContext";
import { useNavigate } from "react-router-dom";


interface ResetSessionProps {
    resetOpen: boolean;
    setResetOpen: (resetOpen: boolean) => void;
}

export const ResetSessionPopup = ({ resetOpen, setResetOpen }: ResetSessionProps) => {

    const navigate = useNavigate();

    const { setCurrentHole, currentHole, setToggleScoring, toggleScoring, isPWA, setScoreLock, windowSize } = useLSContext();
    const { setScoreCode, setEventData, setRegistrationData, setCourseData, setScoreData, setLeaderboardData, setGroupConfirmResult, 
        eventData, courseData, scoreData, currentRound, scoreCode, scoreDataRef, setLeaderboardLastQuery } = useDataContext();
    const { holeSettings, setHoleSettings } = useHoleSettings();

    const resetCookies = () => {
        deleteCookie('momentGolf-ls-current-scoreCode');
        deleteCookie('momentGolf-ls-current-eventId');
        deleteCookie('momentGolf-ls-myEventScoreIDs');

        // Clear context state
        setScoreCode('');
        setEventData({});
        setRegistrationData([]);
        setCourseData({});
        setScoreData([]);
        setLeaderboardData([]);
        setGroupConfirmResult(false);
        setToggleScoring(false);
        setLeaderboardLastQuery(new Date('1/1/2000'));
        setResetOpen(false);
        setScoreLock(false);
        clearLastHole();
        
        setTimeout(() => {
            navigate('/login/');
        }, 500);
    }

    return (
        resetOpen &&
            <PopupMessageWrapper open={resetOpen}>
                <Stack direction="column" spacing={2} alignItems="center">
                    <Typography variant="h6" sx={{ color: 'sepia.dark', fontWeight: 700 }}>Return to Home</Typography>
                    <Typography variant="body1" sx={{ color: 'sepia.main' }}>Are you sure you want to return to the home page?</Typography>
                    <Button variant="contained" fullWidth onClick={() => resetCookies()} sx={{ backgroundColor: 'primary.light', color: 'white', '&:hover': { backgroundColor: 'primary.main' } }}>Yes, Return to Home</Button>
                    <Button variant="contained" fullWidth onClick={() => {
                        setResetOpen(false);
                    }} sx={{ backgroundColor: 'sepia.extraLight', color: 'sepia.dark', '&:hover': { backgroundColor: 'sepia.light', color: 'white' } }}>Stay Put</Button>     
                </Stack>
            </PopupMessageWrapper> 
    )
}